<div
  class="relative mt-6 flex flex-row items-center justify-center gap-2.5 overflow-hidden rounded-3xl border border-solid border-blue-200"
  [ngClass]="{ 'bg-[url(../assets/images/default-map.png)] bg-cover': !location }"
>
  @if (location) {
    <!-- inert removes focus/AT exposure for Google's internal controls (copyright, terms, keyboard shortcuts links) -->
    <google-map height="240" width="700" inert [options]="options">
      @if (options.center) {
        <img #pin src="images/map-pointer.svg" alt="" />
        <map-advanced-marker [position]="options.center" [content]="pin" />
      }
    </google-map>
  } @else {
    @if (hasError) {
      <div
        class="bg-crimson-100 mb-[22px] ml-10 mr-10 mt-[22px] flex h-full w-full items-center justify-center rounded-2xl pb-8 pl-2.5 pr-2.5 pt-8 backdrop-blur"
        data-test="map-error-message"
      >
        <div
          class="flex h-full w-full flex-col items-center justify-center gap-4 text-center text-sm font-medium text-blue-900"
        >
          <i class="block h-12 w-12 bg-[url(../assets/icons/map-pointer-error-icon.svg)]"></i>
          Oops! Google cannot locate your address accurately.
          <p class="font-normal">
            Please check the entered information again or contact us and we’ll help you to order desired service
          </p>
        </div>
      </div>
    } @else {
      <div
        class="m-10 flex h-full w-full items-center justify-center rounded-2xl bg-blue-900 bg-opacity-[0.57] pb-8 pl-2.5 pr-2.5 pt-8 backdrop-blur"
      >
        <div class="flex h-full w-full flex-col items-center justify-center gap-4 text-center text-sm text-white">
          <i class="block h-12 w-12 bg-[url(../assets/icons/map-pointer-icon.svg)]"></i>
          Please specify your location in order to get more precise service details
        </div>
      </div>
    }
  }
</div>
